import { useMemo } from 'react';

import config, { IS_ALLOWED_KATANA_DEPOSIT_WITHDRAW } from '#/config';
import { useSelector } from '#/reduxState/storeCore';

export function useWithdrawDisabledMessage(): string | false {
  const withdrawEnabled = useSelector(
    state => state.exchange.info.withdrawEnabled
  );

  const withdrawalDisabledMessage = useMemo((): false | string => {
    if (config.env === 'sandbox' && !IS_ALLOWED_KATANA_DEPOSIT_WITHDRAW) {
      return 'Withdrawals are disabled in Sandbox.';
    }
    if (!withdrawEnabled) {
      return 'Withdrawals are temporarily disabled.';
    }
    return false;
  }, [withdrawEnabled]);

  return withdrawalDisabledMessage;
}
